// extracted by mini-css-extract-plugin
export default {"tooltip":"hV-z","arrow":"iV-z"};